module.exports = __webpack_public_path__ + "img/charge_bike1.a8e110c7.png";